'use client';

import React from 'react';

import { Button } from '@/components/ui/button';
import DownloadIcon from '@/svgs/download.svg';
import { downloadFiles } from '@/utils/downloadFiles';

type Props = {
  video_link: string;
};

const ContentVideoActions: React.FC<Props> = ({ video_link }) => {
  const [isDownloading, setIsDownloading] = React.useState(false);

  const handleDownload = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.preventDefault();
    setIsDownloading(true);
    try {
      await downloadFiles([{ url: video_link }]);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <div className="flex w-[calc(100%-16px)] justify-between items-center absolute bottom-0 right-0 p-1.5 ">
      <Button
        onClick={(e) => void handleDownload(e)}
        disabled={isDownloading}
        variant="secondary"
        size="sm"
        className="p-1.5"
      >
        {isDownloading ? (
          <div className="h-[18px] w-[18px] animate-spin rounded-full border-2 border-gray-300 border-t-[#252525]"></div>
        ) : (
          <DownloadIcon className="size-[18px]" />
        )}
      </Button>
    </div>
  );
};

export default ContentVideoActions;
